module.exports = __webpack_public_path__ + "342b41ec9dff3099e7af488ae5c00d1a.MP3";